import React from 'react'
import PropTypes from 'prop-types'
import {
    Text,
    HStack,
    Box,
    useMultiStyleConfig,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {useCurrency} from '@salesforce/retail-react-app/app/hooks'
import {useIntl} from 'react-intl'
import InfoPopover from '../popovers/info-popover'
import {InfoIcon} from '../icons'

const WeeeFee = ({price = '', variant = 'default', itemCurrency = ''}) => {
    const styles = useMultiStyleConfig('WeeeFee', {variant})
    const {currency} = useCurrency()
    const intl = useIntl()
    const currentPriceText = intl.formatNumber(price, {
        style: 'currency',
        currency: itemCurrency || currency,
    })

    const label =
        variant === 'default'
            ? intl.formatMessage(
                  {
                      id: 'weee_fee.included',
                      defaultMessage: '{currentPriceText} d’eco-part',
                  },
                  {currentPriceText},
              )
            : variant === 'orderHistory'
            ? intl.formatMessage(
                  {
                      id: 'weee_fee.orderHistory',
                      defaultMessage: '{currentPriceText} Eco tax',
                  },
                  {currentPriceText},
              )
            : intl.formatMessage({
                  id: 'weee_fee.orderSummary',
                  defaultMessage: 'Eco tax',
              })

    return (
        <HStack {...styles.weeeFeeContainer}>
            <HStack {...styles.weeeFeeLabel}>
                <Text {...styles.weeeFeeText}>{label}</Text>
                <InfoPopover
                    trigger={
                        <Box {...styles.infoIconContainer}>
                            <InfoIcon {...styles.infoIcon} />
                        </Box>
                    }
                    variant="right-center"
                    openTooltipOn="hover"
                    title={intl.formatMessage({
                        id: 'weee-fee.info.popover.title',
                        defaultMessage: 'Weee-fee Popover Title',
                    })}
                    description={intl.formatMessage({
                        id: 'weee-fee.info.popover.description',
                        defaultMessage: 'Weee-fee Popover Description',
                    })}
                />
            </HStack>
            {variant !== 'default' && variant !== 'orderHistory' && (
                <Text {...styles.weeeFeeText}>{currentPriceText}</Text>
            )}
        </HStack>
    )
}

WeeeFee.propTypes = {
    variant: PropTypes.string,
    price: PropTypes.number,
    itemCurrency: PropTypes.string,
}
export default WeeeFee
